import loadable from '@loadable/component';

export const OrgDashboardListCreditsContainerLoadable = loadable(
  () => import('./OrgDashboardListCreditsContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardListCreditsContainer,
  },
);
